var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "review-section" }, [
    _c("div", { staticClass: "flex flex-between" }, [
      _c("img", {
        attrs: {
          src: "/images/reviews-logo.png",
          alt: "Habit Health: Google Reviews"
        }
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "button small",
          attrs: { href: _vm.businessUrl, target: "_blank" }
        },
        [_vm._v("Write a review")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "review-count" }, [
      _vm.hasReview ? _c("p", [_vm._v(_vm._s(_vm.rating))]) : _vm._e(),
      _vm._v(" "),
      _vm.hasReview
        ? _c("div", { staticClass: "stars" }, [
            _c("img", {
              attrs: {
                src: "/images/reviews-stars.png",
                alt: "Habit Health: Google Reviews"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasReview
        ? _c("p", { staticClass: "reviews" }, [
            _vm._v(_vm._s(_vm.reviews) + " reviews")
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7411e76d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7411e76d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/GoogleReview.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7411e76d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/GoogleReview.vue
// module chunks = 0